import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicSync({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path d="M2.9 8.73c.4-.11.81.12.92.52a4.25 4.25 0 007.7 1.1h-1.15a.75.75 0 010-1.5h3c.41 0 .75.34.75.75v3a.75.75 0 01-1.5 0v-1.18A5.75 5.75 0 012.38 9.65a.75.75 0 01.52-.92zM8.05 2.2c2.6 0 4.85 1.74 5.54 4.2a.75.75 0 01-1.45.4 4.25 4.25 0 00-7.7-1.1H5.6a.75.75 0 010 1.5h-3a.75.75 0 01-.75-.75v-3a.75.75 0 011.5 0v1.19a5.75 5.75 0 014.7-2.44z" />
    </svg>
  );
}

SvgBasicSync.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicSync.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicSync svgRef={ref} {...props} />);
export default ForwardRef;
